import { combineReducers } from "redux"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import authReducer from "./authReducer"
import generalReducer from "./generalReducer"

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist auth state
}

const appReducer = combineReducers({
  general: generalReducer,
  auth: authReducer,
})

const persistedReducer = persistReducer(persistConfig, appReducer)

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    return persistedReducer(undefined, action)
  }

  return persistedReducer(state, action)
}

export default rootReducer
